import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReceiptDetails from "./receiptDetails";

const PurchaseReturnReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const[cust, setCust] = useState(null)
  const [open , setOpen] = useState(false)
  const[payData , setPayData] = useState([])
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true

  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , 'months').format(),
    toDate : moment().format()
  })
  const onEdit = (e) => {
    console.log(e.row);
    setPayData(e.row)
    setOpen(true);
  };
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth: 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "docNo",
    headerName: "Doc No",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Outlet Name",
    flex:1,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "mode",
    headerName: "Payment Mode",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "chqUtr",
    headerName: "Chq / UTR",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "bank",
    headerName: "Bank",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    disableExport: true ,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return (
        <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon />
        </IconButton>
      );
    },
  },
]
// const currentDate = moment().format('DD-MM-YYYY');
// const filteredData = data.filter(val => moment(val.date).format('DD-MM-YYYY') === currentDate);
const rows = _.map(data ,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.date).format('DD-MM-YYYY'),
  docNo : `Rc ${val.id}`,
  party : val.fullname || "-",
  amount : parseFloat(val.amount).toFixed(0),
  mode : val.mode === 1 ? "Cash" : val.mode === 2 ? "Check / DD" : val.mode === 3 ? "UPI" : "-" ,
  chqUtr:val.chequeno || "-",
  bank:val.bankname || "-",
  receiptLines:val.receipt_lines
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  // function getSupplierData() {
  //   axios
  //     .get("/v1/supplier")
  //     .then((res) => {
  //       setSupplier(res.data);
  //     })
  //     .catch((err) => {
  //       dispatch(setSnackbar(true, "error", err.response.errors[0].message));
  //     });
  // }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleReceiptReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ? cust.id : 0
  }
  console.log(postData)
  axios.post('/v1/reports/sales/receipt', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
  })
}
  useEffect(() => {
    getSupplierData();
  }, []);
  console.log(dateLimit, cust )
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleReceiptReport()
    }
  },[rowsPerPage, page, dateLimit, cust])
  return (
    <Fragment>
      <Helmet><title>Warehouse Receipt Reports</title></Helmet>
      <Typography variant="h6">Warehouse Receipt Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 , fullname : "All"},...supplier]}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{ zIndex: 999999 }}>
          <ReceiptDetails setOpen={setOpen} data={data} payData={payData}/>
      </Backdrop>
    </Fragment>
  );
};

export default memo(PurchaseReturnReport);
